<template>
  <div class="d-flex flex-row justify-space-between">
    <v-label>{{ label }}</v-label>
    <div>
      <v-switch
        color="primary"
        :model-value="modelValue"
        @update:model-value="$emit('update:modelValue', $event)"
        density="compact"
        hide-details
      />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps(["label", "modelValue"]);
defineEmits(["update:modelValue"]);
</script>
